import React, { useState, useRef } from 'react'
import moment from 'moment';

const { $ } = window;
const ModalPromo = ({ listPromo, withCode, onHandleClick, __DMCalculation }) => {
    const [state, setState] = useState({
        position: 1,
        item: [],
        selectedRow: {}
    });

    const promoCode = useRef();
    const DMCalculation = () => {
        __DMCalculation('', '', 'D', '', promoCode.current.value)
        $("#modal-promo-header").modal('hide');
    }

    const changePosition = (position, item) => {
        setState({ ...state, position, item });
    }

    const onChangeHandler = (e, row) => {
        if (e.target.checked) {
            setState({ ...state, selectedRow: row });
        }
    }

    const onClear = () => {
        setState({ ...state, selectedRow: {} });
        $('[name="radio"]').prop('checked', false);
    }

    const { position, item, selectedRow } = state;

    return position == 1
        ?
        <>
            <div className="modal-header">
                <h5 className="modal-title" style={{ fontWeight: '600' }}> Promo Product</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className='modal-body' style={{ paddingLeft: 35, paddingRight: 35 }}>
                {withCode &&
                    <>
                        <p style={{ fontSize: 18, fontWeight: '500' }}>Promo Code</p>
                        <div className='row'>
                            <div className="col-sm-12">
                                <div className="input-group input-group-button">
                                    <input type="text" className="form-control form-input-promo" placeholder='Type promo code' ref={promoCode} />
                                    <div className="input-group-prepend" style={{ position: 'absolute', top: 5, right: 5, zIndex: 10 }} onClick={DMCalculation}>
                                        <span className="input-group-text btn btn-modena" id="basic-addon10" style={{ borderRadius: 5 }}>
                                            <span className="">Apply</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <hr />
                    </>
                }
                {listPromo && listPromo.length > 0 ?
                    <>
                        {listPromo.map((row, index) => (
                            <div className='row' key={`promo-` + index}>
                                <div className="col-sm-1">
                                    <div className="radio radiofill radio-primary radio-inline">
                                        <label>
                                            <input type="radio" className='radio-helper' name="radio" onChange={(e) => onChangeHandler(e, row)} />
                                        </label>
                                    </div>
                                </div>
                                <div className="col-sm-11">
                                    <p style={{ fontWeight: 500 }}>{row.paketid}</p>
                                    <p>{row.keterangan_paket}... <span style={{ fontWeight: 500, cursor: 'pointer' }} onClick={() => changePosition(2, row)}>Lihat Detail</span> </p>
                                </div>
                            </div>
                        ))}
                        <hr />
                        <div className='row' style={{ justifyContent: 'flex-end' }}>
                            <div className='col-sm-6'>
                                <button className="btn btn-readonly btn-block" style={{ marginBottom: 30 }} type="button" onClick={onClear}>
                                    Clear
                                </button>
                            </div>
                            <div className='col-sm-6'>
                                <button className="btn btn-modena btn-block" style={{ marginBottom: 30 }} type="button" onClick={() => onHandleClick(selectedRow)}>
                                    Use
                                </button>
                            </div>

                        </div>
                    </>
                    :
                    <>
                    </>
                }
            </div>
        </>
        :
        <>
            <div className="modal-header">
                <h5 className="modal-title" style={{ fontWeight: '600' }}><span className='fa fa-arrow-left' style={{ cursor: 'pointer' }} onClick={() => changePosition(1)}></span> &nbsp; Promo Product</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className='row'>
                    <div className="col-sm-8">
                        {item.paketid}
                    </div>
                    <div className="col-sm-4">
                        <p style={{ marginBottom: 0 }}>Expired</p>
                        <p style={{ fontWeight: 500 }}>{moment(item.akhir).format('DD MMM YYYY')}</p>
                        {/* <p>{row.keterangan_paket}... <span style={{fontWeight: 500, cursor: 'pointer'}} onClick={() => changePosition(2)}>Lihat Detail</span> </p> */}
                    </div>
                </div>
                <p>{item.keterangan_paket}</p>
            </div>
        </>
}

export default ModalPromo